import { URLS } from '../constants'
import { dispatchFetchGet } from './ActionsUtil'
import {
  GET_MARKETPLACES_BEGIN, 
  GET_MARKETPLACES_FAILURE, 
  GET_MARKETPLACES_SUCCESS, 
} from '../constants/ActionTypes'

const acGetMarketplacesBegin = () => ({ type: GET_MARKETPLACES_BEGIN, })
const acGetMarketplacesSuccess = payload => ({
  type: GET_MARKETPLACES_SUCCESS, payload: { response: payload }
})
const acGetMarketplacesFailure = err => ({
  type: GET_MARKETPLACES_FAILURE, payload: err
})

export const acGetMarketplaces = () => {
  return dispatchFetchGet(
    `${URLS.MARKETPLACE}`,
    acGetMarketplacesBegin,
    acGetMarketplacesSuccess,
    acGetMarketplacesFailure,
  )
}
